import { Component, DoCheck, ViewChild, ElementRef, Input, OnChanges, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { GridOptions } from 'ag-grid';
import * as encoding from 'encoding-japanese';
import { ShipService } from '../../../service/ship/ship.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';

@Component({
  selector: 'app-wa3013',
  templateUrl: './wa3013.component.html',
  styleUrls: ['./wa3013.component.scss']
})
export class Wa3013Component implements AfterViewInit, DoCheck, OnChanges {
  private gridApi: any;
  public componentTitle = 'WA3013:出荷欠品照会';
  private totalCount = 0;
  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];
  public config = config;
  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';
  private gridHelper: AgGridHelper;
  @Input() private window: string;

  @ViewChild('gridView')
  gridView: ElementRef;

  private openwindow: boolean = false;
  private params: number = 1;
  private isEnableClearFilter = false;
  private shortsDetail: string = '';

  @Input()
  isShow = false;
  private stockOutData = null;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = false;

  constructor(private shipService: ShipService, private commonService: CommonService) {
    this.gridHelper = new AgGridHelper();
    this.gridOptions = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      pagination: true,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa3013_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
      },
      onFilterChanged: () => {
        this.gridHelper.onGridFilterChanged();
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.errorInfo = '';
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.gridHelper.fixedAgMenu();
        this.errorInfo = '';
      },
      onSortChanged: () => {
        this.gridHelper.renderGridCheckboxImage();
        this.errorInfo = '';
      },
      onPaginationChanged: () => {
        this.totalCount = this.gridOptions.api.paginationGetRowCount();
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品コード',
        field: 'itemCd',
        unSortIcon: true,
        width: this.getColumnWidth('itemCd', 150),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '指示数',
        field: 'orderpcsNr',
        unSortIcon: true,
        width: this.getColumnWidth('orderpcsNr', 80),
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      },
      {
        headerName: '在庫数',
        field: 'stockNr',
        unSortIcon: true,
        width: this.getColumnWidth('stockNr', 80),
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      },
      {
        headerName: '欠品数',
        field: 'shortNr',
        unSortIcon: true,
        width: this.getColumnWidth('shortNr', 80),
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma,
      },
      {
        headerName: '補充ケース数',
        field: 'esuppcaseNr',
        unSortIcon: true,
        width: this.getColumnWidth('esuppcaseNr', 100),
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma,
      },
      {
        headerName: '補充インナーケース数',
        field: 'esuppinnerNr',
        unSortIcon: true,
        width: this.getColumnWidth('esuppinnerNr', 100),
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma,
      },
      {
        headerName: '補充バラ数',
        field: 'esuppbaraNr',
        unSortIcon: true,
        width: this.getColumnWidth('esuppbaraNr', 100),
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma,
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        unSortIcon: true,
        width: this.getColumnWidth('ownerTx', 150),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品名',
        field: 'itemTx',
        unSortIcon: true,
        width: this.getColumnWidth('itemTx', 100),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロット',
        field: 'lotTx',
        unSortIcon: true,
        width: this.getColumnWidth('lotTx', 100),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ケース入数',
        field: 'caseamountNr',
        unSortIcon: true,
        width: this.getColumnWidth('caseamountNr', 100),
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma,
      },
      {
        headerName: 'インナーケース入数',
        field: 'inneramountNr',
        unSortIcon: true,
        width: this.getColumnWidth('inneramountNr', 100),
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma,
      },
    ];
    this.gridHelper.setGridOptions(this.gridOptions);
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.rowData = [];
  }

  clearFilter() {
    this.gridOptions.api.setFilterModel(null);
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa3013_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa3013_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa3013_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  ngDoCheck() { }

  close() {
    this.closeButtonClick.emit(false);
  }

  changeTabOther(type) {
    this.errorInfo = '';
    this.params = type;
    if (type === 2) {
      const selectItems: object[] = JSON.parse(sessionStorage.getItem('wa3010-checkShort-selectItems'));
      const ownerId: number = Number(sessionStorage.getItem('wa3010-checkShort-ownerId'));
      this.working = true;
      this.shipService
        .checkShortDetail(ownerId, selectItems, 'wa3013')
        .then(outputJson => {
          this.working = false;
          //SWMS-1169対応
          sessionStorage.setItem('shortsDetail', JSON.stringify(outputJson.shorts));
          this.shortsDetail = JSON.stringify(outputJson.shorts);
          if (outputJson.shorts.length === 0) {
            this.errorInfo = '届先単位の欠品はありません';
          }
        })
        .catch(error => {
          this.working = false;
          this.errorInfo = this.commonService.getErrorMessage(error);
        });
    }
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      const shorts: any = JSON.parse(sessionStorage.getItem('shorts'));
      if (shorts === null) {
        sessionStorage.removeItem('otherwindow');
        return;
      }
      this.rowData = shorts;
      if (this.params == 2)
        this.changeTabOther(2);
    } else {
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
      this.stockOutData = null;
    }
  }

  onsubmint() {
    this.onFilterClear();
    this.rowData = JSON.parse(sessionStorage.getItem('shorts'));
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa3Shipment/wa3013/wa3013.component.ts